import React, { useCallback, useContext, useMemo } from "react";
import { Grid, makeStyles, Theme, useMediaQuery, useTheme } from "@material-ui/core";
import { ColorCategoryDictionary } from "../../../models/categories";
import { PageIndicator } from "../../../components/core/page-indicator";
import { ArrowLeftIcon } from "../../../assets/icons/arrows/arrow-left-icon";
import { ArrowRightIcon } from "../../../assets/icons/arrows/arrow-right-icon";
import { PresentationNavButton } from "./../presentation/components/presentation-nav-button";
import { NutritionContext } from "../context/nutrition-context";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme: Theme) => ({
  footer: {
    paddingTop: theme.spacing(10),
  },
  previousButton: {
    marginRight: theme.spacing(2),
  },
  nextSubmenuItemButton: {
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
  },
}));

interface IAnswerWrapperFooterProps {
  activeIndex: number;
  pages: number;
  setAnswerIndex: (index: number) => void;
}
export const AnswerWrapperFooter: React.VFC<IAnswerWrapperFooterProps> = (props) => {
  const { activeCategory, changeActiveCategories, nextCategory, nextSubcategory } = useContext(NutritionContext);
  const { activeIndex, pages, setAnswerIndex } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const theme = useTheme();

  const isLastPage = useMemo(() => activeIndex === pages - 1, [activeIndex, pages]);

  const goToNextPage = useCallback(() => {
    if (!isLastPage) {
      setAnswerIndex(activeIndex + 1);
    } else {
      if (nextCategory && nextSubcategory) {
        changeActiveCategories(nextCategory, nextSubcategory, 1);
      }
    }
  }, [activeIndex, isLastPage, nextCategory, nextSubcategory, setAnswerIndex, changeActiveCategories]);

  const isXs = useMediaQuery(theme.breakpoints.only("xs"));

  return (
    <Grid item container direction="row" justify="space-between" alignItems="center" className={classes.footer}>
      <Grid item>
        <Grid container>
          <Grid item className={classes.previousButton}>
            <PresentationNavButton
              backgroundColor={ColorCategoryDictionary[activeCategory].color}
              onClick={() => setAnswerIndex(activeIndex - 1)}
              disabled={activeIndex === 0}
            >
              <ArrowLeftIcon width={24} />
            </PresentationNavButton>
          </Grid>
          <Grid item>
            {(!isLastPage || isXs) && (
              <PresentationNavButton
                backgroundColor={ColorCategoryDictionary[activeCategory].color}
                onClick={() => goToNextPage()}
              >
                <ArrowRightIcon width={24} />
              </PresentationNavButton>
            )}
            {isLastPage && !isXs && nextCategory && (
              <PresentationNavButton
                className={classes.nextSubmenuItemButton}
                backgroundColor={ColorCategoryDictionary[nextCategory].color}
                onClick={() => goToNextPage()}
              >
                {t(`menu_item_subcategories.navigate_to.${nextSubcategory}`)}
              </PresentationNavButton>
            )}
          </Grid>
        </Grid>
      </Grid>
      <Grid item style={{ alignItems: "flex-end" }}>
        <PageIndicator
          pages={pages}
          activePage={activeIndex}
          colorHEX={ColorCategoryDictionary[activeCategory].color}
          onClickPageIndicator={setAnswerIndex}
        />
      </Grid>
    </Grid>
  );
};
